import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const REQUESTED_CLAIMS_REQUESTED_CLAIM_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/requested-claims',
        iconClass: 'fas fa-file-alt',
        name: '::Menu:RequestedClaims',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.RequestedItems.CustomerClaims',
        order: 0,
      },
    ]);
  };
}
